import type { SystemStyleObject } from '@/styled-system/types';
import { Gleam, VisuallyHidden } from '@zillow/constellation-10';

type UnreadIndicatorProps = {
  count?: number;
  dataTestId?: string;
  css?: SystemStyleObject;
};

export default function UnreadIndicator({ count, dataTestId = '', css }: UnreadIndicatorProps) {
  return (
    <Gleam.Root>
      <Gleam.Label
        appearance="dot"
        // Required by Gleam.Label but never rendered in dot appearance; the announcement
        // below is what reaches assistive tech.
        count={count ?? 0}
        renderDot={({ ref: _ref, ...dotProps }) => <Gleam.Dot {...dotProps} />}
        tone="default"
        data-testid={dataTestId}
        css={css}
      />
      <VisuallyHidden>{count === undefined ? 'New message(s)' : `${count} New message(s)`}</VisuallyHidden>
    </Gleam.Root>
  );
}
